var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OverviewView"},[_c('UserPanel'),_c('ModalContainer',{staticClass:"modalContainer",attrs:{"name":"social-modal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }